module.exports = __webpack_public_path__ + "img/male-avatar2.d04209ff.png";